import React from 'react';
import styled from 'styled-components';

const StandardFormBoxContainer = styled.div<{ $width: string }>`
    width: ${({ $width }) => $width};
    border: 2px solid #58585A;
    border-radius: 30px;
    margin-bottom: 1rem;
    border-color: linear-gradient(to right, #3B56A6, #2081C4);
`;

const StandardHeader = styled.div`
    display: flex;
    border-bottom: 2px solid #58585A;
    border-radius: 30px 30px 0px 0px ;
`;

const GradientFormBoxContainer = styled.div<{ $width: string }>`
    width: ${({ $width }) => $width};
    padding: 2.5px; /* Adjust this to match your desired border thickness */
    padding-left: 3px;
    border-radius: 32px; /* Slightly larger than your original border-radius */
    margin-bottom: 2rem;

    background: linear-gradient(to right, #3B56A6, #2081C4), white; /* Gradient and background color */
    background-origin: border-box; /* Ensures the gradient covers the border area */
    background-clip: padding-box, border-box; /* Applies the background to the padding (border) and the content */
`;

const GradientHeader = styled.div`
    display: flex;
    border-radius: 30px 30px 0px 0px ;
    margin-bottom: 3px;
`;

const Title = styled.span`
    display: flex;
    justify-content: center;
    font-size: 1rem;
    font-weight: 500;
    padding: 1rem 0;
    background: #E9ECF6;
    width: 100%;
    border-radius: 30px 30px 0px 0px ;
`;

const Content = styled.div`
    background: #FFFFFF;
    border-radius: 0px 0px 30px 30px;
    overflow: visible;
`;

interface FormBoxProps {
    variant: "standard" | "gradient";
    headerVariant?: "title" | "component";
    headerTitle?: string;
    headerComponent?: React.ReactNode;
    children?: React.ReactNode;
    width: string;
}

const FormBox: React.FC<FormBoxProps> = ({ variant, headerVariant, headerTitle, headerComponent, children, width }) => {

    return (
        <>
            {variant === "standard" && <StandardFormBoxContainer $width={width}>
                <StandardHeader>
                    {headerVariant === "title" && <Title>{headerTitle}</Title>}
                    {headerVariant === "component" && headerComponent}
                </StandardHeader>
                <Content>
                    {children}
                </Content>
            </StandardFormBoxContainer>}

            {variant === "gradient" && <GradientFormBoxContainer $width={width}>
                <GradientHeader>
                    {headerVariant === "title" && <Title>{headerTitle}</Title>}
                    {headerVariant === "component" && headerComponent}
                </GradientHeader>
                <Content>
                    {children}
                </Content>
            </GradientFormBoxContainer>}
        </>
    );
}

export default FormBox;
